import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Badge.css';

class Badge extends Component {
  render() {
    const number = this.props.number;
    const showEmpty = this.props.showEmpty;
    return (number || showEmpty) ? (
      <span className={classNames(s.Badge, s[this.props.className])}>
        {!showEmpty ? number : null}
      </span>
    ) : null;
  }
}

Badge.propTypes = {
  number: PropTypes.number,
  className: PropTypes.string,
  showEmpty: PropTypes.bool,
  history: PropTypes.bool,
}

export default withStyles(s)(Badge);



// WEBPACK FOOTER //
// ./src/components/Badge/Badge.js